export enum BalanceUpdateReasonsEnum {
    BET = 'BET',
    DEPOSIT = 'DEPOSIT',
    INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
}
